import React, { useMemo, useState } from "react";
import { forumApi } from "../../utils/forumApi";
import {
  Button,
  FieldGrid,
  FieldGroup,
  Form,
  FormCard,
  HelperText,
  HiddenField,
  Input,
  Notice,
  Textarea,
} from "./ForumStyles";

const initialValues = {
  body: "",
  authorName: "",
  authorEmail: "",
  honeypot: "",
};

function ReplyForm({ questionId, onSubmitted }) {
  const renderedAt = useMemo(() => Date.now(), []);
  const [values, setValues] = useState(initialValues);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ type: "", message: "" });
    setIsSubmitting(true);

    try {
      const response = await forumApi.submitReply({
        ...values,
        questionId,
        renderedAt,
      });

      setStatus({
        type: "success",
        message:
          response?.message ||
          "Your reply has been submitted and is waiting for admin review.",
      });
      setValues(initialValues);

      if (typeof onSubmitted === "function") {
        onSubmitted(response);
      }
    } catch (error) {
      setStatus({
        type: "error",
        message:
          error instanceof Error
            ? error.message
            : "Could not submit your reply. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormCard>
      <Form onSubmit={handleSubmit}>
        {status.message ? (
          <Notice $type={status.type === "error" ? "error" : "success"}>
            {status.message}
          </Notice>
        ) : null}

        <FieldGroup>
          Your Reply
          <Textarea
            name="body"
            value={values.body}
            onChange={handleChange}
            placeholder="Share a practical answer, a clarification, or the next best step."
            minLength={10}
            maxLength={3000}
            required
          />
        </FieldGroup>

        <FieldGrid>
          <FieldGroup>
            Your Name
            <Input
              type="text"
              name="authorName"
              value={values.authorName}
              onChange={handleChange}
              placeholder="Your name"
            />
          </FieldGroup>

          <FieldGroup>
            Email Address
            <Input
              type="email"
              name="authorEmail"
              value={values.authorEmail}
              onChange={handleChange}
              placeholder="your@email.com"
            />
          </FieldGroup>
        </FieldGrid>

        <HiddenField
          type="text"
          name="honeypot"
          value={values.honeypot}
          onChange={handleChange}
          tabIndex="-1"
          autoComplete="off"
        />

        <HelperText>
          Replies are reviewed before they become visible. Keep your answer helpful,
          professional, and directly related to the question.
        </HelperText>

        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit Reply"}
        </Button>
      </Form>
    </FormCard>
  );
}

export default ReplyForm;
